import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import bwipjs from 'bwip-js';

const ViewProductionOutput = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(51));

    axios
      .get(`/production-output/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.production);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDownload = async () => {
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    var barcode_number = value.barcode_number;
    axios
      .get(`/production-output/pdf/${id}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = barcode_number + '.pdf';
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
      })
      .catch((error) => {
        console.error('Error downloading PDF:', error);
      });
  };

  const editItem = () => {
    window.location.href = "/production-output-edit/" + id;
  };

  /**
   * ✅ bwip-js renders onto a hidden <canvas>, then exports to PNG base64.
   * 100% synchronous — no React rendering, no setTimeout needed.
   * bwip-js is the industry-standard engine used in warehouse/logistics systems.
   * scale:4 ensures crisp bars that scan instantly even on low-quality scanners.
   */
  const generateBarcodeDataURL = (barcodeValue) => {
    try {
      const canvas = document.createElement('canvas');
      bwipjs.toCanvas(canvas, {
        bcid: 'code128',          // CODE128 — best for alphanumeric data
        text: barcodeValue,
        scale: 4,                 // scale 4 = crisp bars (higher = better scan quality)
        height: 20,               // bar height in mm (20mm = standard warehouse label)
        includetext: true,        // show human-readable number below bars
        textxalign: 'center',
        textsize: 14,
        paddingwidth: 10,         // quiet zone left/right — critical for scanning!
        paddingheight: 5,         // quiet zone top/bottom
        backgroundcolor: 'ffffff',
        barcolor: '000000',
      });
      return canvas.toDataURL('image/png');
    } catch (err) {
      console.error('bwip-js barcode generation failed:', err);
      return '';
    }
  };

  const handleSemiFinishedClick = (barcode_data) => {
    const originalBarcodeNumber = barcode_data.barcode_number;

    // ✅ Generate barcode synchronously — instant, no delays
    const barcodeDataURL = generateBarcodeDataURL(originalBarcodeNumber);

    let get_contents = '';
    get_contents += '<div id="div-print" style="padding: 5px;">';

    get_contents += '<div style="text-align: center; margin-bottom: 10px;">';
    get_contents += '<h3 style="font-size: 36px; margin-bottom: 10px;">Semi Finished Output Details</h3>';
    get_contents += '<hr style="border: 2px solid #000; margin: 20px 0;">';
    get_contents += '</div>';

    get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5; width: 35%;">Barcode#</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + originalBarcodeNumber + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Date And Time</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.date_time || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift Date</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift_date || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Location</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.location_name ? barcode_data.location_name.title : '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Package Type</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.packaging_name || '') + '</td></tr>';
    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Lot Number</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + barcode_data.toal_lot_number + '</td></tr>';
    get_contents += '</table><br/>';

    get_contents += '<h5 style="font-size: 24px; margin: 10px 0; text-align: left;">Items Details</h5>';
    get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';
    get_contents += '<thead>';
    get_contents += '<tr style="background-color: #f5f5f5;">';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Product</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Number Of Boxes</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Gross Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Boxes weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Pallets Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Net Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Output Type</th>';
    get_contents += '</tr>';
    get_contents += '</thead><tbody>';

    if (barcode_data.contents && Array.isArray(barcode_data.contents)) {
      barcode_data.contents.forEach((item, index) => {
        const rowBgColor = index % 2 === 0 ? '#ffffff' : '#f9f9f9';
        get_contents += `<tr style="background-color: ${rowBgColor};">`;
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.product_name || ''}</td>`;
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.number_of_boxes || ''}</td>`;

        const grossWeight = typeof item.gross_weight === 'number' ? item.gross_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${grossWeight}</td>`;

        const boxWeight = typeof item.box_weight === 'number' ? item.box_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${boxWeight}</td>`;

        const palletWeight = typeof item.pallet_weight === 'number' ? item.pallet_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${palletWeight}</td>`;

        const netWeight = typeof item.net_weight === 'number' ? item.net_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${netWeight}</td>`;

        const outputTypeLabel = item?.output_type === 1 ? 'Finished' : 'Semi Finished';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${outputTypeLabel}</td>`;
        get_contents += '</tr>';
      });
    }

    get_contents += '</tbody></table><br/>';

    // ✅ Embed as PNG <img> — base64 inline, loads instantly, no external requests
    get_contents += '<div style="text-align: center; margin-top: 30px;">';
    if (barcodeDataURL) {
      get_contents += `<img src="${barcodeDataURL}" alt="Barcode: ${originalBarcodeNumber}" style="max-width: 60%; height: auto; display: block; margin: 0 auto;" />`;
    }
    get_contents += '</div>';
    get_contents += '</div>';

    const width = 500;
    const height = 600;
    const widthInPixels = width * 3.779527559;
    const heightInPixels = height * 3.779527559;
    const left = (window.screen.width - widthInPixels) / 2;
    const top = (window.screen.height - heightInPixels) / 2;
    const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

    const printWindow = window.open('', '', windowFeatures);
    printWindow.document.open();
    printWindow.document.write(`<html>
      <head>
        <title>Production Output - ${originalBarcodeNumber}</title>
        <style>
          @media print {
            body { margin: 0; padding: 20px; }
          }
          table { page-break-inside: avoid; }
          tr { page-break-inside: avoid; page-break-after: avoid; }
          img { display: block; margin: 0 auto; }
        </style>
      </head>
      <body style="font-family: Arial, sans-serif; margin: 0; padding: 20px;">
        ${get_contents}
      </body>
    </html>`);
    printWindow.document.close();

    // ✅ onload fires after full paint — eliminates all timing/delay issues
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-output">Production Output</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Production Output
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.list === 1 && (
                    <div className="card-body">
                      <h4 className="card-title">View Production Output Info</h4>
                      <div style={{ float: "right" }}>
                        <button
                          onClick={() => editItem()}
                          className="btn btn-danger me-1"
                        >
                          Edit Production Output
                        </button>

                        {value.total_output_type == 'Semi Finished' && (
                          <button
                            onClick={() => handleSemiFinishedClick(value)}
                            className="btn btn-primary ms-2"
                          >
                            Print Label{' '}
                            <i className="fa fa-print" />
                          </button>
                        )}
                        
                        {value.total_output_type == 'Finished' && (
                        <button
                          onClick={() => handleDownload()}
                          className="btn btn-primary me-1"
                        >
                          Download Production Output{" "}
                          <i className="fa fa-print" />{" "}
                          <img
                            id="loader-image"
                            className="loader-image loader-hide"
                            src={loader_image}
                            alt="loading"
                          />
                        </button>
                        )}
                        
                      </div>

                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th className="p-3">Barcode Number</th>
                            <td className="p-3">{value.barcode_number}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Date Time</th>
                            <td className="p-3">{value.date_time}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Shift</th>
                            <td className="p-3">{value.shift}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Shift Date</th>
                            <td className="p-3">{value.shift_date}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Location</th>
                            <td className="p-3">
                              {value.location ? value.location_name.title : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Packaging Type</th>
                            <td className="p-3">{value.packaging_name}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Lot Number</th>
                            <td className="p-3">{value.toal_lot_number}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Supplier</th>
                            <td className="p-3">{value.supplier_name}</td>
                          </tr>
                        </tbody>
                      </table>

                      <br />
                      <h5 className="card-title">Items</h5>

                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className="p-3">Product</th>
                            <th className="p-3">No Of Boxes</th>
                            <th className="p-3">Gross Weight(KG)</th>
                            <th className="p-3">Boxes weight (KG)</th>
                            <th className="p-3">Pallets Weight (KG)</th>
                            <th className="p-3">Net Weight(KG)</th>
                            <th className="p-3">Output Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {value.contents &&
                            value.contents.map((item, indx) => (
                              <tr key={item.calibre || indx}>
                                <td className="p-3">{item.product_name}</td>
                                <td className="p-3">{item.number_of_boxes}</td>
                                <td className="p-3">
                                  {typeof item.gross_weight === 'number'
                                    ? item.gross_weight.toFixed(2)
                                    : '0'}
                                </td>
                                <td className="p-3">
                                  {typeof item.box_weight === 'number'
                                    ? item.box_weight.toFixed(2)
                                    : '0'}
                                </td>
                                <td className="p-3">
                                  {typeof item.pallet_weight === 'number'
                                    ? item.pallet_weight.toFixed(2)
                                    : '0'}
                                </td>
                                <td className="p-3">
                                  {typeof item.net_weight === 'number'
                                    ? item.net_weight.toFixed(2)
                                    : '0'}
                                </td>
                                <td className="p-3">
                                  <div>
                                    {item?.output_type === 1
                                      ? 'Finished'
                                      : 'Semi Finished '}

                                    {item?.output_type == '2' && (
                                      <button
                                        onClick={() => handleSemiFinishedClick(value)}
                                        className="btn btn-primary ms-2"
                                      >
                                        Print Label{' '}
                                        <i className="fa fa-print" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewProductionOutput;